export class StudioPluginContractError extends TypeError {
  constructor(message, code = "INVALID_STUDIO_PLUGIN") {
    super(message);
    this.name = "StudioPluginContractError";
    this.code = code;
  }
}

export class StudioPluginRegistryError extends Error {
  constructor(message, code = "STUDIO_PLUGIN_REGISTRY_ERROR") {
    super(message);
    this.name = "StudioPluginRegistryError";
    this.code = code;
  }
}

export class StudioCapabilityContractError extends TypeError {
  constructor(message, code = "INVALID_STUDIO_CAPABILITY") {
    super(message);
    this.name = "StudioCapabilityContractError";
    this.code = code;
  }
}

export class StudioCapabilityRegistryError extends Error {
  constructor(message, code = "STUDIO_CAPABILITY_REGISTRY_ERROR") {
    super(message);
    this.name = "StudioCapabilityRegistryError";
    this.code = code;
  }
}
